import { Badge, Tooltip } from '../../../../core'
import type { BadgeProps } from '../../../../core'
import type { components } from '@joyful/openapi/types.gen'
import { KpiEmailStateSchema } from '../utils/kpiEmailSchemas'
import { formatTimestamp } from '@joyful/utils'

export interface KpiEmailStateBadgeProps extends Omit<BadgeProps, 'children'> {
  skippedAt: components['schemas']['KpiEmailRead']['skipped_at']
  skippedReason: components['schemas']['KpiEmailRead']['skipped_reason']
  state: components['schemas']['KpiEmailState']
}

export function KpiEmailStateBadge({
  size,
  skippedAt,
  skippedReason,
  state,
  ...restProps
}: KpiEmailStateBadgeProps) {
  const meta = KpiEmailStateSchema.meta(state)
  const Icon = meta.icon

  const badge = (
    <Badge
      variant={meta.variant}
      size={size}
      startAdornment={<Icon className="size-3.5" />}
      {...restProps}
    >
      {meta.title}
    </Badge>
  )

  if (skippedAt !== null) {
    return (
      <Tooltip
        content={
          <div className="flex flex-col gap-y-1">
            <p className="text-tremor-content text-sm">
              {`Skipped at ${formatTimestamp(skippedAt)}`}
            </p>
            {skippedReason !== null ? (
              <p className="text-sm italic">{skippedReason}</p>
            ) : null}
          </div>
        }
      >
        {badge}
      </Tooltip>
    )
  }

  return badge
}
